import React, { FC } from 'react'
import { asText } from '@prismicio/helpers'
import { FAQPageJsonLd } from 'next-seo'
import { Slice, SliceZone } from '@prismicio/types'
import { TFaq } from 'common/cms-types'
import Accordion from 'components/Accordion'
import { RichText } from 'components/forms/RichText'
import HeadingAndText from 'components/HeadingAndText'
import Strings from 'project/localisation'
import SocialLinks from 'components/SocialLinks'

export type FAQJSONLDType = {
  title?: string
  subtitle?: string
  slices: SliceZone<Slice<'faq', TFaq>>
  styledAsRichTextForBlog?: boolean
  expandAllButton?: boolean
  expandAllButtonDesktopOnly?: boolean
}

const FAQList: FC<FAQJSONLDType> = ({
  expandAllButton = false,
  expandAllButtonDesktopOnly = false,
  slices,
  styledAsRichTextForBlog = false,
  subtitle,
  title = `${Strings.frequentlyAskedQuestions}`,
}) => {
  const faqs = slices?.filter((v) => v.slice_type === 'faq')
  const faqJSONLd = faqs?.map((v) => ({
    acceptedAnswerText: asText(v.primary.answer),
    questionName: v.primary.question,
  }))
  return faqs?.length ? (
    <>
      <FAQPageJsonLd mainEntity={faqJSONLd} />
      {!styledAsRichTextForBlog ? (
        <div className='d-flex justify-content-md-center'>
          <div className='col-lg-9 col-12'>
            <div className='mb-lg-19 mb-14'>
              <HeadingAndText
                classesForTitle='fs-fluid-36-80 lh-105 lh-lg-114'
                colSize={12}
                headingSize={2}
                title={title || Strings.frequentlyAskedQuestions}
                subtitle={subtitle || Strings.faqDescription}
                classesForSubTitle={
                  'fs-fluid-18-24 lh-119 lh-lg-123 px-sm-0 px-6 mt-lg-2 mt-3'
                }
              />
            </div>
            <div className={'px-2'}>
              <Accordion
                headerSize={3}
                expandAllButton={expandAllButton}
                expandAllButtonDesktopOnly={expandAllButtonDesktopOnly}
                items={faqs.map((v) => ({
                  body: (
                    <RichText
                      isBlog={false}
                      className='mb-6'
                      text={v.primary.answer}
                    />
                  ),
                  title: v.primary.question,
                }))}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <h2 className={'px-md-20'}>{Strings.faq}</h2>
          {faqs.map((v) => {
            return (
              <>
                <h3 className={'px-md-20'}>{v.primary.question}</h3>
                <RichText isBlog text={v.primary.answer} />
              </>
            )
          })}
          <div className={'px-md-20 mt-md-14 mt-6'}>
            <SocialLinks linkType='share' />
          </div>
        </>
      )}
    </>
  ) : null
}

export default FAQList
